import { TruckStopOrdersSkeleton } from "./TruckStopOrdersCard.styles";
import { Skeleton } from "@mui/material";

const TruckStopOrdersCardSkeleton = () => {
	return (
		<TruckStopOrdersSkeleton>
			<Skeleton
				height={48}
				variant="rectangular"
			/>
			<div>
				<div>
					<Skeleton
						height={24}
						width={128}
						variant="rectangular"
					/>
					<div>
						<div>
							<Skeleton
								height={12}
								variant="rectangular"
							/>
							<Skeleton
								height={12}
								variant="rectangular"
							/>
						</div>
						<div>
							<Skeleton
								height={12}
								variant="rectangular"
							/>
							<Skeleton
								height={12}
								variant="rectangular"
							/>
						</div>
					</div>
				</div>
				<div>
					<Skeleton
						height={24}
						width={128}
						variant="rectangular"
					/>
					<div>
						<div>
							<Skeleton
								height={12}
								variant="rectangular"
							/>
							<Skeleton
								height={12}
								variant="rectangular"
							/>
						</div>
						<div>
							<Skeleton
								height={12}
								variant="rectangular"
							/>
							<Skeleton
								height={12}
								variant="rectangular"
							/>
						</div>
					</div>
				</div>
			</div>
		</TruckStopOrdersSkeleton>
	);
};

export default TruckStopOrdersCardSkeleton;
